module.exports = __webpack_public_path__ + "img/upload.88462aaf.svg";